// import { ENV } from "@/const";

const store = {
  namespaced: true,
  getters: {
    // eslint-disable-next-line
    is_admin(state, getters, rootState, rootGetters) {
      const i = rootGetters["user/user"];
      return i.is_super_admin ? true : false;
    },
    admin_pusat(state, getters, rootState, rootGetters) {
      const i = rootGetters["user/user"];
      return i.lingkup.tingkat == 1 ? true : false;
    },
    admin_propinsi(state, getters, rootState, rootGetters) {
      const i = rootGetters["user/user"];
      return i.lingkup.tingkat == 2 ? true : false;
    },
    admin_kota(state, getters, rootState, rootGetters) {
      const i = rootGetters["user/user"];
      return i.lingkup.tingkat == 3 ? true : false;
    },
    admin_kecamatan(state, getters, rootState, rootGetters) {
      const i = rootGetters["user/user"];
      return i.lingkup.tingkat == 4 ? true : false;
    },

    // eslint-disable-next-line
    menus(state, getters, rootState, rootGetters) {
      const user = rootGetters["user/user"];
      const u = user.lingkup;

      return [
        {
          icon: "mdi-home-variant-outline",
          title: "Informasi Terkini",
          new: false,
          to: {
            name: "home"
          },
          hidden: false
        },
        {
          icon: "mdi-alert",
          title: "Pengumuman",
          new: false,
          to: {
            name: "pengumuman"
          },
          hidden: getters["admin_kota"] || (user.peran && user.peran.id == 2)
        },
        {
          icon: "mdi-file",
          title: "Rekap",
          new: false,
          hidden: !getters["admin_pusat"],
          items: [
            {
              icon: "mdi-file",
              title: "Laporan",
              new: false,
              to: {
                name: "laporan.pusat"
              },
              hidden: !getters["admin_pusat"]
            },
            {
              icon: "mdi-file",
              title: "Dokumen",
              new: false,
              to: {
                name: "dokumen.pusat"
              },
              hidden: !getters["admin_pusat"]
            }
          ]
        },
        {
          icon: "mdi-file",
          title: "Rekap Laporan Propinsi",
          new: false,
          to: {
            name: "laporan.propinsi",
            params: {
              propinsi_id: u.id
            }
          },
          hidden: !getters["admin_propinsi"]
        },
        {
          icon: "mdi-file",
          title: "Rekap Dokumen Propinsi",
          new: false,
          to: {
            name: "dokumen.propinsi",
            params: {
              propinsi_id: u.id
            }
          },
          hidden: !getters["admin_propinsi"]
        },
        {
          icon: "mdi-file",
          title: "Rekap Laporan Kota",
          new: false,
          to: {
            name: "laporan.kota",
            params: {
              propinsi_id: u.propinsi_id,
              kota_id: u.id
            }
          },
          hidden: !getters["admin_kota"]
        },
        {
          icon: "mdi-file",
          title: "Rekap Dokumen Kota",
          new: false,
          to: {
            name: "dokumen.kota",
            params: {
              propinsi_id: u.propinsi_id,
              kota_id: u.id
            }
          },
          hidden: !getters["admin_kota"]
        },
        {
          icon: "mdi-file",
          title: "Rekap Laporan Kecamatan",
          new: false,
          to: {
            name: "laporan.kecamatan",
            params: {
              propinsi_id: u.propinsi_id,
              kota_id: u.kota_id,
              kecamatan_id: u.id
            }
          },
          hidden: !getters["admin_kecamatan"]
        },
        {
          icon: "mdi-account",
          title: "Kelola Pengguna",
          new: false,
          to: {
            name: "user"
          },
          hidden: getters["admin_kota"] || getters["admin_kecamatan"]
        },
        {
          icon: "mdi-account-group",
          title: "Data Anggota",
          new: false,
          to: {
            name: "warga"
          },
          hidden: false
        },
        {
          icon: "mdi-account-check",
          title: "Pengurus",
          new: false,
          to: {
            name: "pengurus"
          },
          hidden: false
        },
        {
          icon: "mdi-file",
          title: "Dokumen",
          new: false,
          to: {
            name: "dokumen"
          },
          hidden:  getters["admin_kecamatan"]
        }
      ];
    }
  }
};

export default store;
